var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveIncome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_716_3023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_716_3023)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 18,
    fill: "#5367FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_716_3023",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_716_3023",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACBwAAAgcBLDp1nAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAATXSURBVHic7dpbiFVVGMDx35kZLU3ykpbmBawojSmDbiZE0eWhC1RaBt0hqB6iCxQ9aVe6WVhBRoZPpRkI9RBZICFpF0ukLO02aXSTKKUhm8ZGZ3pY58zZM7PPOXufs49K7T+sh7NY37e+dfvWt759yMnJycnJycnJycn5P1LYj32dizOboPdXvIx99Qi3pWw/HcfW0c+peBQtdcgmoR1vp5TpxsdpBG5GD/r+Q2VN0sHfi96DwOCsy7ZaPqCAx3BfpG4Jfqgh14q7Mb5Gu0bowwsJbCkxXrCptfh7Ny6vJtCKF5Vnqxd3JuhoOF7T3JVLakuJSdgckd+FOWkGsRc3JehoJFY3MLAkpQc3JrClxHR0ROR34ORqAocJHrUk0I25CToajXUNDq5W6cYVCWwpMRM/ReS34bhqAmPxfkRgNy5M0NE4bGhwcLXKn7gggS0lTsNvEfkvMLmawER8FhHYhbMSdDQJnzc4uFplJ2YnsKXEOeiMyG/AEdUEpuPbiEDNcxKR+67BwdUqv+CkBLaUuBRdEfk1GFWpcQGz8A6OKtb1YVFxYNVow8KIXDPoxRP4PmH7iVigHOGuxA2C44wyRvAla+FLzV3BA1WWiA+9T1HetR2w8SAwNuvySMzA4XoDj8emghAhXYxDKwhV4mqcl1ImDQ8K5z8tW7F+UN1wPI3bI3XrMb8+0wLPiJ/9OwSPOzZhaRfvSNsbMS7C0cJgo7qfw7BGFcdNwL46FT8foyuLCThbuNFKOruEY9BP2nxALVqEG2SFcoLiH2GFuyLtJgseG6bgqoztILwVFikvyHYhov00qw4qHYG40onbIrKzE8jUuwNGYvkgXauFaHUIbcKrb4ryMzEpoyvU/4FNwh0eZS7eFGLzj/AqJmAajo/RM8XAXZOEcVimHMT1CZmohTH29POWbK+gmSmNbhECkqyvwk5cVqXPOcLDz+8ZdrpPWNW0rMx48FvE7yrCjnuv2O6DgpCtnS/9EZgj/pxuEc5cXJZ2sZDFJWSZxgoO8RpDo7ZVwoMsLTvwlPCSHcw8vFTsl+QhdixpnGA37onIzkogk1UcQHCMSwfp34r2rK9BwgyvUnY6XcKu6Cz+bsWzTei3ErMEhxv1TUuF/GBaJzuAuB2wV/VAaJihK9GsHVAQYoHuiM6dkmW3ElHpCMRlWo/EddIlThqZgAnClRvVtxZTG9A5hEoTsMfAWT4Er1do24wJOB8/R/T04AEVnHxByPnNk/47YaVbgHIWeXnx93C8Il3IW88tMAZXKt8o23EtPqwmtFO2d3A0Jrg10k+rEKU1o6+4skLlaBVmCAvjjSYa0Wvg9VeQ7vqsp+xS/bvBVOXod10hUpn2GbtAso8l8LAQj5d4qChfjYvwTUqbCOd/T0x9AbfgSRxerNtRh/5+0q7kYgP9zJoa7bMMhI7Bu4P0f40zGlFaz1ZeJviCFrU/pGQxAS24C39F9O4VMs0jGlVe71n+SvhKU6tdoxMww8CvXH3CB9LTG9TbT7OdWb0T0CZEgNFV78HjQkwypPEo4Tta2nfBtDoNTMps5bRZUkbgfuEvOSU2Cv9u2VxJ6BPNXckDVf4Wntw1F/bHg8DYrMt6nFBr4IRr6URconn/4NrfdAhvj4o5wJycnJycnJycnJycnH8BhaEnzk43M+AAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIncome);
export default __webpack_public_path__ + "static/media/activeIncome.df6c5644961e0a0e9945572bba049a15.svg";
export { ForwardRef as ReactComponent };